define('controllers/pendingreservations',['require','johngrid'],function (require) {
    var CreateJohnGrid = require('johngrid');
    return function() {
        var grid_UnLinked = CreateJohnGrid(),
            unlinkedColumns = [{ DataField: "EMail" },
                                 { DataField: "NameFirst", HeaderText: "Name" },
                                 { DataField: "ReservationDate", HeaderText: "Reservation Date <span class='sideNote'>(click to see vacation)</span>" },
                                 { DataField: "NextEventDate", HeaderText: "Next Event Date <span class='sideNote'>(click to see schedule)</span>" },
                                 { DataField: "Phone" },
                                 { DataField: "Phone2" }];

        grid_UnLinked.init($("#tblUnLinked"), unlinkedColumns, "UnLinkedAJAX.aspx");
        grid_UnLinked.databind();

        function setUpResetLinks(grid) {
            $("a.ResetMicro", grid.$table).off("click").on("click", function (e) {
                e.preventDefault();

                var $this = $(this),
                    AccountId = grid.utilities.getItemForRowClick($this).AccountID;


                grid.setGridLoading(true);

                $.post(grid.datasourceURL, { method: "resetMicroAttempts", AccountId: AccountId }, function (response) {
                    Utilities.handleAJAXResponse(response, function (newData) {
                        grid.databind(newData);
                    },
                    function (error) {
                        grid.utilities.setError(error);
                    });
                }).complete(function () {
                    grid.setGridLoading(false);
                });
            });
        }

        var grid_Unverified = CreateJohnGrid(),
            tblUnverified = $("#tblUnverified"),
            UnVerifiedAJAX = "UnVerifiedAJAX.aspx",
            unVerifiedColumns = [{ DataField: "EMail" },
                                 { DataField: "NameFirst", HeaderText: "Name" },
                                 { DataField: "ReservationDate", HeaderText: "Reservation Date <span class='sideNote'>(click to see vacation)</span>" },
                                 { DataField: "LinkDate", HeaderText: "Link Date" },
                                 { DataField: "BusinessDaysAfterLink5", HeaderText: "5 Business Days After Link Date" },
                                 { DataField: "MicroAttempts", HeaderText: "Micro Attempts" },
                                 { DataField: "Phone" },
                                 { DataField: "Phone2" }];

        grid_Unverified.init(tblUnverified, unVerifiedColumns, UnVerifiedAJAX);
        grid_Unverified.onDataBound = function () { setUpResetLinks(grid_Unverified); };
        grid_Unverified.databind();


        var grid_Unverified_UnBooked = CreateJohnGrid(),
            Unverified_UnBooked_Columns = [{ DataField: "Email" },
                                 { DataField: "NameFirst", HeaderText: "Name" },
                                 { DataField: "RDate", HeaderText: "Reconciled Date" },
                                 { DataField: "BusinessDaysAfterLink5", HeaderText: "5 Business Days After Link Date" },
                                 { DataField: "MicroAttempts", HeaderText: "Micro Attempts" }];

        grid_Unverified_UnBooked.init($("#tblUnverified_NotBooked"), Unverified_UnBooked_Columns, "Unverified_NoReservation_AJAX.aspx");
        grid_Unverified_UnBooked.onDataBound = function () { setUpResetLinks(grid_Unverified_UnBooked); };
        grid_Unverified_UnBooked.databind();
    };
});

